export default class UserService {
  constructor(axios) {
    this.axios = axios
  }

  /**
   * @param {string} id
   */
  async roles(id) {
    const { data: { data } } = await this.axios.get(`users/${id}/roles`)
    return data.map(item => item.Role.name)
  }

  /**
   * @param {string} id
   */
  async modules(id) {
    const { data: { data } } = await this.axios.get(`users/${id}/modules`)
    return data.map(item => item.Module)
  }
}
